import { FolderFilled, FolderOpenFilled } from '@ant-design/icons';
import { Button, ButtonProps } from 'antd';
import styled from 'styled-components';
import { DocumentalIcon } from './DocumentalIcon';

const DocumentalFolderButtonWrapper = styled(Button)`
  padding-left: 0;
  max-width: 100%;
  height: auto;
  min-height: 32px;
`;

const ButtonTextEllipsis = styled.div`
  white-space: wrap;
  text-align: left;
`;

export interface IDocumentalFolderButtonProps extends ButtonProps {
  isOpen: boolean;
}

/**
 * Container impostare colore e dimensione icona.
 */
export function DocumentalFolderButton(props: IDocumentalFolderButtonProps) {
  const { isOpen, children, ...rest } = props;
  return (
    <DocumentalFolderButtonWrapper
      {...rest}
      type="link"
      icon={
        <DocumentalIcon>
          {isOpen ? (
            <FolderOpenFilled aria-hidden />
          ) : (
            <FolderFilled aria-hidden />
          )}
        </DocumentalIcon>
      }
    >
      <ButtonTextEllipsis>{children}</ButtonTextEllipsis>
    </DocumentalFolderButtonWrapper>
  );
}
